// extracted by mini-css-extract-plugin
export default {"card":"ProfileCard_card__aIV6E","employeePersonalCard":"ProfileCard_employeePersonalCard__ahrqh"};